import { useUser as useClerkUser } from '@clerk/clerk-react';
import { useSelector } from 'react-redux';

const useUser = () => {
  const { user: clerkUser } = useClerkUser();
  const authorization = useSelector((state) => state.user.jwt);
  const sameUser = authorization.id === clerkUser?.id;

  return {
    jwt: {
      id: clerkUser?.id,
      imageUrl: clerkUser?.imageUrl,
      username: clerkUser?.username,
      companyId: clerkUser?.publicMetadata?.companyId,
      email: clerkUser?.primaryEmailAddress?.emailAddress,
      alertEmail: clerkUser?.publicMetadata?.alertEmail,
      emailIsVerified: clerkUser?.primaryEmailAddress?.verification?.status === 'verified',
      name: clerkUser?.fullName,
      admin: sameUser && authorization.admin === true,
      companyChannel: clerkUser?.publicMetadata?.companyChannel,
      role: sameUser ? authorization.role : null,
      roleId: sameUser ? authorization.roleId : null,
      permissions: sameUser ? authorization.permissions : null,
      adminChannel: clerkUser?.publicMetadata?.adminChannel,
      userChannel: clerkUser?.publicMetadata?.userChannel,
      completedTutorials: clerkUser?.publicMetadata?.completedTutorials || [],
      twoFactorEnabled: clerkUser?.twoFactorEnabled,
      quickStartProgress: clerkUser?.unsafeMetadata?.quickStartProgress || {},
      embeddedProgress: clerkUser?.unsafeMetadata?.embeddedProgress || {}
    },
    settings: {
      name: clerkUser?.fullName,
      email: clerkUser?.primaryEmailAddress?.emailAddress,
      alertEmail: clerkUser?.publicMetadata?.alertEmail,
      alerts: {
        operationsExceeded: clerkUser?.publicMetadata?.alerts?.operationsExceeded ?? true,
        operationsExceededThreshold: clerkUser?.publicMetadata?.alerts?.operationsExceededThreshold ?? 90
      }
    }
  };
};

export default useUser;
